<div>
  <div
    class="tableFixHead mx-2 pb-2"
    [ngClass]="{
      tableHeight: app.filterTable.isDropdownOpen
    }"
    >
    <table class="table table-striped">
      <thead>
        <tr>
          @for (column of copyOfColumns; track column) {
            <th class="p-1">
              <div class="d-inline-flex">
                <div
                [ngClass]="{
                  'resize-table': app.table.canColumnBeResized(column)
                }"
                  >
                  <span
                  (click)="
                    app.table.toggleSortDirection(column);
                    app.table.sort(app.detailTable.docs)
                  "
                    >
                    {{ app.field.handleSpecialLogicLabels(column) }}
                  </span>
                  @if (column === 'remove') {
                    <div>
                      @if (app.table.selected.size === 0) {
                        <i
                          class="far fa-square"
                          (click)="app.table.selectAll(app.detailTable.docs, true)"
                        ></i>
                      }
                      @if (app.table.selected.size > 0) {
                        <i
                          class="far fa-check-square"
                          (click)="app.table.clearSelection()"
                        ></i>
                      }
                    </div>
                  }
                  &nbsp;
                  @if (column === app.table.sortField) {
                    <span>
                      @if (app.table.sortDirection === 1) {
                        <i
                          class="fa fa-chevron-up"
                        ></i>
                      }
                      @if (app.table.sortDirection === -1) {
                        <i
                          class="fa fa-chevron-down"
                        ></i>
                      }
                    </span>
                  }
                </div>
              </div>
              @if (
                app.filterTable.getFilterTableColumns(
                app.mail.getColumnShort(column)
                )
                ) {
                <div
                  >
                  <app-filter-table
                    [column]="app.mail.getColumnShort(column)"
                    [columns]="columns"
                    [docType]="type"
                    [cleanDocs]="app.detailTable.cleanDocs"
                    [selectedFilters]="selectedFilters"
                (resultedDocs)="
                  app.filterTable.getFilterResults($event, 'detailTable')
                "
                    >
                  </app-filter-table>
                </div>
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (
          id of showPaginator
          ? app.paginator.getPage(app.detailTable.docs)
          : app.detailTable.docs; track
          id; let i = $index) {
          <tr
            class="pointer"
            [ngClass]="{ isSelected: app.isSelected(id) }"
            >
            @for (column of cleanColumns; track column) {
              <td class="p-1">
                <div>
                  @switch (app.table.getColumnTypeDisplay(column)) {
                    @case ('normal') {
                      <div (click)="navigate(id, column)">
                        @if (
                          type === 'part' &&
                          app.unlockedId != null &&
                          (column === 'designator' ||
                          column === 'sapItemCategory')) {
                          @if (column === 'designator') {
                            <input
                              type="text"
                              class="form-control lineHeight underline"
                              [ngModel]="id[column] || ''"
                              (click)="$event.stopPropagation()"
                    (ngModelChange)="
                      app.detailTable.updateBomEntry(id, column, $event)
                    "
                              />
                          }
                          @if (column === 'sapItemCategory') {
                            <select
                              class="form-control lineHeight underline"
                              [ngModel]="id[column] || ''"
                              (click)="$event.stopPropagation()"
                    (ngModelChange)="
                      app.detailTable.updateBomEntry(id, column, $event)
                    "
                              >
                              <option value=""></option>
                              @for (
                                option of app.field.getOptions(
                                app.fieldId.part.sapItemCategory
                                )
                                ; track
                                option) {
                                <option
                                  [value]="option"
                                  >
                                  {{ option }}
                                </option>
                              }
                            </select>
                          }
                        } @else {
                          {{
                          getColumnValue(id, column)
                          }}
                        }
                      </div>
                    }
                    @case ('badge') {
                      <div (click)="navigate(id, column)">
                        <span
                          class="badge badgeStatus"
                          [ngStyle]="app.field.getColor('part.' + column, id[column])"
                          >
                          {{ app.field.getOptionText("part." + column, id[column]) }}
                        </span>
                      </div>
                    }
                    @case ('limit') {
                      <div (click)="navigate(id, column)">
                        @if (
                          type === 'part' &&
                          app.unlockedId != null &&
                          column === 'designator') {
                          <input
                            type="text"
                            class="form-control lineHeight underline"
                            [ngModel]="id[column] || ''"
                            (click)="$event.stopPropagation()"
                    (ngModelChange)="
                      app.detailTable.updateBomEntry(id, column, $event)
                    "
                            />
                        } @else {
                          <app-limit
                            [textInput]="getColumnValue(id, column)"
                            limit="20"
                          ></app-limit>
                        }
                      </div>
                    }
                    @case ('navigateAction') {
                      <div>
                        <a class="partNumber" (click)="navigate(id, column)">{{
                          id[column]
                        }}</a>
                      </div>
                    }
                    @case ('actions') {
                      <div>
                        @if (column === 'remove') {
                          <button
                            class="btn btn-hidden pt-0 ps-0"
                            (click)="app.table.toggleSelect(id); $event.stopPropagation()"
                            >
                            @if (app.table.selected.has(id)) {
                              <i
                                class="far fa-check-square"
                              ></i>
                            }
                            @if (!app.table.selected.has(id)) {
                              <i
                                class="far fa-square"
                              ></i>
                            }
                          </button>
                        }
                        @if (column === 'createCase') {
                          <span>
                            @if (
                              !app.thread.getCase(id) &&
                              id.manufacturerPartNumber !== ''
                              ) {
                              <i
                                class="far fa-folder-plus click-area icon-blue"
                                (click)="app.thread.newCase(id)"
                              ></i>
                            }
                            @if (app.thread.getCase(id)) {
                              <i
                                class="fas fa-folder-open click-area icon-blue"
                    (click)="
                      seeOpenedCasesModal.open();
                      app.manufacturersFilter.currentManufacturer = id;
                      app.thread.getCasesByPartNumber(id)
                    "
                              ></i>
                            }
                          </span>
                        }
                      </div>
                    }
                    @case ('checkBox') {
                      <div (click)="navigate(id, column)">
                        @if (column === 'valid') {
                          <span>
                            @if (
                              !id[column] || id[column] == null || id[column] === ''
                              ) {
                              <i
                                class="far fa-square"
                              ></i>
                            }
                            @if (id[column]) {
                              <i class="far fa-check-square"></i>
                            }
                          </span>
                        }
                      </div>
                    }
                    @case ('radio') {
                      <div (click)="navigate(id, column)">
                        @if (column === 'active') {
                          <span>
                            @if (app.field.isTrue(id[column])) {
                              <i
                                class="fas fa-star-of-life"
                              ></i>
                            }
                          </span>
                        }
                      </div>
                    }
                    @case ('textCenter') {
                      <div class="text-center">
                        {{ id[column] }}
                      </div>
                    }
                  }
                </div>
              </td>
            }
          </tr>
        }
        <tr>
          @if (loading) {
            <td colspan="99" class="text-center">
              {{ app.text.core.loading }}
            </td>
          }
          @if (!loading && app.detailTable.docs.length === 0) {
            <td
              colspan="99"
              class="text-center"
              >
              {{ app.text.part.bomNoResults }}
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
  <app-modal
    #seeOpenedCasesModal
    [modalTitle]="app.text.thread.threads"
    [modalType]="'showListOfCases'"
    [showButtons]="false"
    >
  </app-modal>
</div>
